import { driver } from 'driver.js'
import 'driver.js/dist/driver.css'

let switchAccountImg = require('@/assets/images/guide/switch_account.gif')
let accountSettingImg = require('@/assets/images/guide/account_setting.gif')
let depositGuideImg = require('@/assets/images/guide/deposit_guide.gif')

export function guide() {
  import('@/lang/index').then(res => {
    let i18n = res.default

    const guideStep = [
      {
        element: '#account_0',
        popover: {
          className: 'guide-close',
          title: `<div class="switch-account"> <img src="${accountSettingImg}" class="guide-img" alt=""></div>`,
          description: `<div class="driver-popover-content">
                              <div class="driver-popover-title">${i18n.t('guide.accManagement')}</div>
                              <div class="driver-popover-desc">${i18n.t('guide.accManagementDesc')}</div>
                              <div class="driver-popover-desc mt-0">${i18n.t('guide.accManagementDesc2')}</div>
                          </div>`,
          side: 'right',
          showButtons: ['next'],
          nextBtnText: `${i18n.t('common.button.next')}`,
          onPopoverRender: (popover, { config, state }) => {
            const firstButton = document.createElement('button')
            firstButton.className = 'driver-popover-close-btn'
            firstButton.innerText = `${i18n.t('common.button.skip')}`
            popover.footerButtons.appendChild(firstButton)

            firstButton.addEventListener('click', () => {
              driverObj.destroy()
            })
          },
        },
      },
      {
        element: '#account_selector_left',
        popover: {
          className: 'guide-close',
          title: `<div class="switch-account"> <img src="${switchAccountImg}" class="guide-img" alt=""></div>`,
          description: `<div class="driver-popover-content">
                                    <div class="driver-popover-title">${i18n.t('guide.accFilters')}</div>
                                    <div class="driver-popover-desc">${i18n.t('guide.accFiltersDesc')}</div>
                                </div>`,
          side: 'bottom',
          align: 'center',
          showButtons: ['next'],
          nextBtnText: `${i18n.t('common.button.next')}`,
          onPopoverRender: (popover, { config, state }) => {
            const secondButton = document.createElement('button')
            secondButton.className = 'driver-popover-close-btn'
            secondButton.innerText = `${i18n.t('common.button.skip')}`
            popover.footerButtons.appendChild(secondButton)

            secondButton.addEventListener('click', () => {
              driverObj.destroy()
            })
          },
        },
      },
      {
        element: '#header_guide',
        popover: {
          className: 'guide-close',
          title: `<div class="switch-account"> <img src="${depositGuideImg}" class="guide-img" alt=""></div>`,
          description: `<div class="driver-popover-content">
                                  <div class="driver-popover-title">${i18n.t('guide.depositProcess')}</div>
                                  <div class="driver-popover-desc">${i18n.t('guide.depositProcessDesc')}</div>
                              </div>`,
          side: 'bottom',
          align: 'start',
          showButtons: ['next'],
          doneBtnText: `${i18n.t('guide.expNow')}`,
        },
      },
    ]
    const driverObj = driver({
      showProgress: false,
      allowClose: false,
      steps: guideStep,
    })

    driverObj.drive()
  })
}
